/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class IDs {
  /**
  * The IDs of the object
  */
  'ids'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "ids",
      "baseName": "ids",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return IDs.attributeTypeMap;
  }

  public constructor() {
  }
}

